/* eslint-disable */
import { DecorativeIcon } from '@netlify/ui';
import { AlertContents } from '../Alert/Alert.js';
import { parseProps } from '../Alert/helpers.js';
import { alertCN, contentsCN, iconCN } from './styles.js';
import { type AlertSmallProps } from './types.js';

const AlertSmall = ({
  id,
  variant,
  outset,
  className,
  iconClassName,
  inline,
  skipNotifyError,
  ...rest
}: AlertSmallProps) => {
  const { message, state, role, icon } = parseProps(rest);

  if (!message) {
    return null;
  }

  const Component = inline ? 'span' : 'div';

  return (
    <Component
      className={alertCN({ outset, state, variant, className })}
      role={role}
    >
      <DecorativeIcon
        name={icon}
        height={24}
        className={iconCN({ state, iconClassName })}
      />
      <AlertContents
        as={Component}
        id={id}
        className={contentsCN}
      >
        {message}
      </AlertContents>
    </Component>
  );
};

export default AlertSmall;
